import React, { useState } from 'react';
import PropTypes from 'prop-types';
import truncate from 'lodash/truncate';
import get from 'lodash/get';

import SmallPrint from 'Components/SmallPrint';
import DangerousHTML from 'Components/Utility/DangerousHTML';

export default function LegalNotice({ notice }) {
  const [showMore, setshowMore] = useState(false);

  if (!notice) return false;

  const legalNotice = get(notice, 'legal', '');
  const shortLegal = truncate(legalNotice, { length: 1500, separator: ' ' });

  return (
    <section data-nosnippet className="text-muted">
      {!showMore &&
        <div>
          <DangerousHTML
            html={shortLegal}
            className="paragraph-small"
          />
          {legalNotice && legalNotice.length > 1500 &&
            <button className="btn btn-link-primary btn-small-print" onClick={() => { setshowMore(true); }}>
              Show more
            </button>
          }
        </div>
      }
      {showMore &&
        <DangerousHTML
          html={legalNotice}
          className="paragraph-small"
        />
      }
      <SmallPrint />
    </section>
  );
}

LegalNotice.propTypes = {
  notice: PropTypes.shape({
    legal: PropTypes.string,
  }),
};

LegalNotice.defaultProps = {
  notice: null,
};
